module.exports = __webpack_public_path__ + "static/carusel-livechat-b1fbf7e7b45398912ed570492a4af0d7.webp";